import axios from 'axios'

const HOST_URL = `${process.env.REACT_APP_HOST_URL}/proreference`
const HOST_URL_NO_AUTH = `${process.env.REACT_APP_NO_AUTH_HOST_URL}/proreference`

const GENERIC_HOST_URL = `${process.env.REACT_APP_HOST_URL}`
const GENERIC_HOST_URL_NO_AUTH = `${process.env.REACT_APP_NO_AUTH_HOST_URL}`
// const GENERICMETADATA_HOST_URL = `${process.env.REACT_APP_METADATA_HOST_URL}`

const HeadersFromCookies = (user) => {
  const headers = {
    headers: {
      /* eslint-disable-next-line */
      Authorization: `Bearer ${user.jwt}`,
      'x-correlationId': '1',
      'Ocp-Apim-Subscription-Key': process.env.REACT_APP_OCPKEY,
      'Ocp-Apim-Trace': true,
      'Content-Type': 'application/json'
    }
  }

  return {
    headers: user.isTSCRequest
      ? {
        ...headers.headers,
        isTSCRequest: true
      }
      : {
        ...headers.headers,
        Passport: true,
        AuthorizationType: user.authorizationType
      }
  }
}

export async function getMetaData (user) {
  if (user === null || user === undefined)
    throw new Error('cookies must be defined')
  const promise = new Promise((resolve, reject) => {
    // FIX ME: REMOVE THIS WHEN WRAPPERS ARE CREATED
    // START MOCK DATA:
    // resolve({
    //   data: mockMetaData,
    //   status: 200
    // })
    // return
    // // END MOCK DATA

    // /* eslint-disable-next-line */
    axios
      .get(
        `${
          user.noAuth ? GENERIC_HOST_URL_NO_AUTH : GENERIC_HOST_URL
        }/proreference/metadata`,
        HeadersFromCookies(user)
      )
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
  return promise
}

/**
 * @param {*} TID The TID of the user
 * @param {*} workHistoryID The work historyID for the reference
 * @param {*} user Cookies passed in for Authorization
 */
export async function getProfileInformation (TID, user) {
  if (user === null || user === undefined)
    throw new Error('cookies must be defined')
  const promise = new Promise((resolve, reject) => {
    axios
      .get(
        `${
          user.noAuth ? GENERIC_HOST_URL_NO_AUTH : GENERIC_HOST_URL
        }/profile?travellerId=${TID}`,
        HeadersFromCookies(user)
      )
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
  return promise
}

/**
 * @param {*} TID The TID of the user
 * @param {*} workHistoryID The work historyID for the reference
 * @param {*} user Cookies passed in for Authorization
 */
export async function getWorkHistoryAndReferences (TID, workHistoryID, user) {
  if (user === null || user === undefined)
    throw new Error('cookies must be defined')
  const workHistory = await getWorkHistory(TID, workHistoryID, user)
  const references = await getReferences(TID, workHistoryID, user)
  return {
    workHistory,
    references
  }
}

/**
 * @param {*} TID The TID of the user
 * @param {*} workHistoryID The work historyID for the reference
 * @param {*} ReferenceID The work refernceid for the reference
 * @param {*} user Cookies passed in for Authorization
 */
export async function updateEvaluationSubmission (
  TID,
  workHistoryID,
  ReferenceID,
  user,
  data
) {
  if (user === null || user === undefined)
    throw new Error('cookies must be defined')
  const promise = new Promise((resolve, reject) => {
    axios
      .put(
        `${
          user.noAuth ? HOST_URL_NO_AUTH : HOST_URL
        }?tID=${TID}&wID=${workHistoryID}&referenceID=${ReferenceID}`,
        data,
        HeadersFromCookies(user)
      )
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
  return promise
}

/**
 * @param {*} TID The TID of the user
 * @param {*} workHistoryID The work historyID for the reference
 * @param {*} user Cookies passed in for Authorization
 */
export async function getWorkHistory (TID, workHistoryID, user) {
  if (user === null || user === undefined)
    throw new Error('cookies must be defined')
  const promise = new Promise((resolve, reject) => {
    axios
      .get(
        `${
          user.noAuth ? HOST_URL_NO_AUTH : HOST_URL
        }/WorkHistory/${TID}/${workHistoryID}`,
        HeadersFromCookies(user)
      )
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
  return promise
}

/**
 * @param {*} TID The TID of the user
 * @param {*} workHistoryID The work historyID for the reference
 * @param {*} user Cookies passed in for Authorization
 * @param {*} referenceID ID to get a single reference (OPTIONAL). If not included, All references will be returned
 */
export async function getReferences (TID, workHistoryID, user, referenceID) {
  if (user === null || user === undefined)
    throw new Error('cookies must be defined')
  const promise = new Promise((resolve, reject) => {
    axios
      .get(
        //https://enterpriseapi-dev.amnservices.com/api/v1/proreference/reference

        //https://enterpriseapi-dev.amnservices.com/api/v1/proreference/reference?tId=790967&workHistoryId=3130220&referenceId=3168002
        `${user.noAuth ? HOST_URL_NO_AUTH : HOST_URL}/reference?tid=${
          user.tid
        }&workHistoryId=${workHistoryID}&referenceId=${referenceID}`,
        HeadersFromCookies(user)
      )
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })

  return promise
}

/**
 * @param {*} TID The TID of the user
 * @param {*} workHistoryID The work historyID for the reference
 * @param {*} user Cookies passed in for Authorization
 */
export async function postReferences (TID, workHistoryID, user, data) {
  if (user === null || user === undefined)
    throw new Error('cookies must be defined')
  const promise = new Promise((resolve, reject) => {
    axios
      .post(
        //https://enterpriseapi-dev.amnservices.com/api/v1/proreference?tID={TID}&wID={workHistoryID}

        `${HOST_URL}?tId=${TID}&wId=${workHistoryID}`,
        data,
        HeadersFromCookies(user)
      )
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })

  return promise
}
export async function generateEmail (user, data) {
  if (user === null || user === undefined)
    throw new Error('cookies must be defined')
  const promise = new Promise((resolve, reject) => {
    axios
      .post(`${GENERIC_HOST_URL_NO_AUTH}/email`, data, HeadersFromCookies(user))
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
  return promise
}
